import React from "react";
import { Tab, TabList, TabProps, Tabs } from "@chakra-ui/react";
import { Link, useParams } from "react-router-dom";

interface Tab {
  id: number;
  to: string;
  name: string;
}

interface NavigationTabsProps {
  tabs: Record<string, Tab>;
  tabProps?: TabProps;
}

const NavigationTabs: React.FC<NavigationTabsProps> = ({ tabs, tabProps }) => {
  // we take name from url and check do we have such page, if our tabs have this url we set tab id to the index props
  const urlParams = useParams();
  const tabIndex = (urlParams["*"] && tabs[urlParams["*"]]?.id) || 0;

  return (
    <Tabs variant="soft-rounded" index={tabIndex}>
      <TabList display="flex" flexWrap="wrap">
        {Object.values(tabs)?.map(tab => {
          return (
            <Tab
              key={tab.id}
              as={Link}
              replace
              to={tab.to}
              _selected={{ bg: "dark.500", color: "white" }}
              _focus={{ boxShadow: "none" }}
              {...tabProps}
            >
              {tab.name}
            </Tab>
          );
        })}
      </TabList>
    </Tabs>
  );
};

export default NavigationTabs;
